import { Checkbox, Stack } from '@chakra-ui/react'
import {
  CheckboxGroupFormControl,
  InputFormControl,
  TextareaFormControl,
} from 'BrokerTsLib/src/components'
import { Insurer, Risk } from 'BrokerTsLib/src/enums'
import { useFormContext } from 'BrokerTsLib/src/rhf'

import { FormBody } from '@/containers/forms/FormBody'
import { FormRow } from '@/containers/forms/FormRow'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { usePartner } from '@/context/PartnerContext'
import { useSelectedQuote } from '@/context/SelectedQuoteContext'

import type { Step4FormValues } from '../Step4'

const EssoxMeetingRecordForm = () => {
  const methods = useFormContext<Step4FormValues>()
  const { offer } = useSelectedQuote()
  const { isContracted } = useInsuranceParams()
  const { currentPartner } = usePartner()

  // obcas pri prvnim renderu po sjednani zustaval jeste tento formular a padalo to. Neumim zatim resit jinak (callback na useEffect ve Step4.tsx nezabral)
  if (!methods) return null

  const showPlaceOfContract =
    offer?.insurerId == Insurer.GeneraliCeskaPojistovna ||
    offer?.insurerId == Insurer.CPP ||
    offer?.insurerId == Insurer.Uniqa

  return (
    <FormBody>
      <TextareaFormControl
        name="meetingRecord.irregularities"
        label="Případné nesrovnalosti mezi požadavky Zákazníka a sjednávaným
          pojištěním nebo jeho podstatnou změnou"
        isDisabled={isContracted}
        control={methods.control}
      />

      <TextareaFormControl
        name="meetingRecord.reasons"
        label="Důvody, na kterých je doporučení založeno"
        isDisabled={isContracted}
        control={methods.control}
      />

      {currentPartner?.partner == 'AutoEsa' && (
        <TextareaFormControl
          name="meetingRecord.additionalClientRequirements"
          label="Bližší specifikace požadavků a potřeb klienta"
          isDisabled={isContracted}
          control={methods.control}
        />
      )}

      <EffectsAndRisksField />

      {showPlaceOfContract && (
        <FormRow>
          <InputFormControl
            name="meetingRecord.placeOfContract"
            label="Místo sjednání"
            isDisabled={isContracted}
            control={methods.control}
          />
        </FormRow>
      )}
    </FormBody>
  )
}

export default EssoxMeetingRecordForm

const baseSelections = [
  { id: 1, description: 'Pojištění vzniká zaplacením prvního pojistného.' },
  {
    id: 2,
    description:
      'Pozdní uhrazení nebo neuhrazení pojistného může mít vliv na platnost pojistné smlouvy se všemi důsledky, které z její neplatnosti plynou.',
  },
  {
    id: 3,
    description: 'Seznámení s VPP.',
  },
]

const HAVSelections = [
  {
    id: 4,
    description:
      'Havarijní pojištění kryje škody způsobené na pojištěném vozidle.',
  },
  {
    id: 5,
    description:
      'V případě havarijního pojištění může pojišťovna vyžadovat prohlídkou vozidla.',
  },
  {
    id: 6,
    description:
      'Sledujte aktuální hodnotu pojištěného vozidla, vůči sjednané pojistné částce.',
  },
  {
    id: 7,
    description:
      'Změna výše pojistného úpravou hodnoty vozidla může mít vliv na změny pojistného krytí (riziko podpojištění).',
  },
  {
    id: 8,
    description:
      'Je-li v případě havarijního pojištění sjednaná spoluúčast, klient se podílí na způsobené škodě tak jak ji zvolil.',
  },
]

const NOTPOVSelections = [
  {
    id: 9,
    description:
      'Pojištění odpovědnosti za újmu způsobenou provozem vozidla je povinné pojištění, v případě nepojištěného vozidla se klient vystavuje pokutě ČKP.',
  },
]

const EffectsAndRisksField = () => {
  const { offer } = useSelectedQuote()
  const { isContracted } = useInsuranceParams()

  const isPOV = offer?.parts.some((x) => x.riskId === Risk.POV)
  const isHAV = offer?.parts.some((x) => x.riskId === Risk.HAV)

  const selections = [
    ...baseSelections,
    ...(isHAV ? HAVSelections : []),
    ...(!isPOV ? NOTPOVSelections : []),
  ]

  const { clearErrors } = useFormContext()

  return (
    <Stack gap={4}>
      <CheckboxGroupFormControl
        name="meetingRecord.effectsAndRisks"
        label="Vysvětlení dopadů sjednání nebo podstatné změny pojištění na
          zákazníka, včetně souvisejících rizik"
        isDisabled={isContracted}
        valueAsNumber
        isRequired
      >
        {selections.map((item) => (
          <Checkbox value={item.id} key={item.id}>
            {item.description}
          </Checkbox>
        ))}
      </CheckboxGroupFormControl>
      <TextareaFormControl
        name="meetingRecord.effectsAndRisksText"
        placeholder="Individuální záznam"
        isDisabled={isContracted}
        onChange={() => clearErrors('meetingRecord.effectsAndRisks')}
      />
    </Stack>
  )
}
